import { render, staticRenderFns } from "./PurchaserDetails.vue?vue&type=template&id=19a631aa&scoped=true&"
import script from "./PurchaserDetails.vue?vue&type=script&lang=js&"
export * from "./PurchaserDetails.vue?vue&type=script&lang=js&"
import style0 from "./PurchaserDetails.vue?vue&type=style&index=0&id=19a631aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a631aa",
  null
  
)

export default component.exports